import { getContentLocale } from '@/lib/contentLocale';
import { WEB_SUBSCRIBE_HOST } from '@/lib/storeClient';

/** Texte informatif sans lien d'achat (règle stores Apple / Google). */
export function WebPurchaseNotice({ className }: { className?: string }) {
  const locale = getContentLocale();
  return (
    <p className={className}>
      {locale === 'en'
        ? `Subscriptions are sold only on the Exam Copilot website (${WEB_SUBSCRIBE_HOST}), from a web browser. They are not available in this app.`
        : `Les abonnements s’achètent uniquement sur le site Exam Copilot (${WEB_SUBSCRIBE_HOST}), depuis un navigateur web. Ils ne sont pas proposés dans cette application.`}
    </p>
  );
}
